<template>
  <div class="businessApplicationDetails">
    <div class="businessApplicationDetails-first">
      <div class="businessApplicationDetails-word">基本信息</div>
      <div :v-model="businessApplicationVO" class="businessApplicationDetail-message">
        <table class="businessApplicationTable" style="width: 100%">
          <tr>
            <td class="tableLabel">商务编号</td>
            <td>{{businessApplicationVO.businessApplicationNO}}</td>
            <td class="tableLabel">客户名称</td>
            <td>{{businessApplicationVO.customerName}}</td>
            <td class="tableLabel">付款方式</td>
            <td>{{businessApplicationVO.paymentTypeName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">联系人</td>
            <td>{{businessApplicationVO.contact}}</td>
            <td class="tableLabel">联系方式</td>
            <td>{{businessApplicationVO.mobile}}</td>
            <td class="tableLabel">联系人职位</td>
            <td>{{businessApplicationVO.contactPositionName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">有效期限</td>
            <td>
              <div v-if="businessApplicationVO.timeLimit === 20">
                {{businessApplicationVO.beginDate}}
                至
                {{businessApplicationVO.endDate}}
              </div>
              <div v-else-if="businessApplicationVO.timeLimit === 30">永久有效</div>
              <div v-else>一次有效</div>
            </td>
            <td class="tableLabel">本次销售量</td>
            <td>{{businessApplicationVO.salesQuantity}}</td>
            <td class="tableLabel">年销售总量</td>
            <td>{{businessApplicationVO.yearSalesQuantity}}</td>
          </tr>
          <tr>
            <td class="tableLabel">状态</td>
            <td style="width: 350px">
              {{businessApplicationVO.statusName}}
            </td>
            <td class="tableLabel">提交时间:</td>
            <td>{{businessApplicationVO.submitTime}}</td>
            <td class="tableLabel">制单人</td>
            <td>{{businessApplicationVO.creatorName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">制单时间</td>
            <td>{{businessApplicationVO.createdDate}}</td>
            <td class="tableLabel">免包装和运输费用</td>
            <td>{{businessApplicationVO.containsFee ? "是" : "否"}}</td>
            <td class="tableLabel">包装运输费用</td>
            <td>{{businessApplicationVO.packDeliveryFee}}</td>
          </tr>
          <tr>
            <td class="tableLabel">申请理由</td>
            <td colspan="5">{{businessApplicationVO.reason}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注</td>
            <td colspan="5">{{businessApplicationVO.note}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="businessApplicationDetails-seond">
      <div class="businessApplicationDetails-seond-top">
        <el-table :data="businessApplicationVO.priceVOS" border style="width: 100%; margin-top: 20px">
          <el-table-column label="物料编号" width="180">
            <template slot-scope="scope">
              <a style="user-select: initial" @click="openPreviewPage(scope.row)">{{scope.row.materialNo}}</a>
            </template>
          </el-table-column>
          <el-table-column label="规格型号" prop="specification"/>
          <el-table-column label="物料名称" show-overflow-tooltip prop="materialName"/>
          <el-table-column label="物料类型" width="120" align="center" prop="materialTypeName"/>
          <el-table-column label="执行价" width="180">
            <template slot-scope="scope">
              <div>成本价：{{scope.row.costPrice === null ? "****" : scope.row.costPrice}}</div>
              <div>标准价：{{scope.row.standardPrice === null ? "****" : scope.row.standardPrice}}</div>
              <div>一阶：{{scope.row.level1Price === null ? "****" : scope.row.level1Price}}</div>
              <div>二阶：{{scope.row.level2Price === null ? "****" : scope.row.level2Price}}</div>
              <div>三阶：{{scope.row.level3Price === null ? "****" : scope.row.level3Price}}</div>
            </template>
          </el-table-column>
          <el-table-column label="申请价格" width="100" align="center" prop="price"/>
          <el-table-column label="经理审核价格" width="120" align="center" prop="approve1Price">
            <template slot-scope="scope">
              <el-input v-model="scope.row.approve1Price" :disabled="nodeId !== 'regionManager'" @input="priceInput"/>
            </template>
          </el-table-column>
          <el-table-column label="财务审核价格" width="120" align="center" prop="approve2Price">
            <template slot-scope="scope">
              <el-input v-model="scope.row.approve2Price" :disabled="nodeId !== 'fiApprove'" @input="priceInput"/>
            </template>
          </el-table-column>
          <el-table-column
              v-if="businessApplicationVO.approveStatus === 3"
              label="人工费"
              width="100"
              align="center"
              prop="manualPrice"/>
          <el-table-column
              v-if="businessApplicationVO.approveStatus === 3"
              label="材料费"
              width="100"
              align="center"
              prop="materialPrice"/>
          <el-table-column label="总经理审核价格" width="120" align="center" prop="approve3Price">
            <template slot-scope="scope">
              <el-input v-model="scope.row.approve3Price" :disabled="nodeId !== 'GeneralManager'"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-table ref="payData1" border :data="businessApplicationVO.attachments" style="width: 100%; margin-top: 20px">
          <el-table-column type="index" align="center" label="#"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
          <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <same-customer-level-dialog ref="preview" @save-success="getData()"/>
    <preview-page ref="previewPage"/>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>

<script>
  import constant from "../../util/constant";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import SameCustomerLevelDialog from "../SalesManage/businessApplication/SameCustomerLevelDialog";
  import previewPage from "./BusinessApplicationMaterialPreview";

  export default {
    name: "BusinessApplicationPreview",
    components: {SameCustomerLevelDialog, HandleDetail, previewPage},
    props: {
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        billId: "",
        billType: "",
        sequId: "",
        dialogVisible: false,
        loading: false,
        constant,
        businessApplicationVO: {
          businessApplicationID: 0,
          approveStatus: 0,
          priceVOS: [],
          optionalPriceVOS: [],
        },
        nodeId: "",
        isHidden: false,
        expands: [],
        ruleValidate: {
          orderNo: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.billId = val.query.billId;
            this.billType = val.query.billType;
            this.sequId = val.query.sequId;
            this.getData();
          }
        },
      },
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.expands.push(1);
    },
    methods: {
      getData() {
        this.$emit("loading-status", {loading: true});
        this.$http.get("basic", `sd/ba/${this.billId}/${this.sequId}`).then((resp) => {
          this.$emit("loading-status", {loading: false});
          this.businessApplicationVO = resp.data;
          this.getNodeValue();
        });
      },
      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getNodeValue() {
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.nodeId = resp.data.nodeId;
        });
      },

      doApprove() {
        let billParam = [];
        for (let item of this.businessApplicationVO.priceVOS) {
          let object = {};
          if (this.businessApplicationVO.approveStatus === 10) {
            object.costPrice = item.costPrice;
            object.costFloatingPrice = item.costFloatingPrice;
          } else if (this.businessApplicationVO.approveStatus === 1) {
            object.approve1Price = item.approve1Price;
            object.approve1FloatingPrice = item.approve1FloatingPrice;
          } else if (this.businessApplicationVO.approveStatus === 2) {
            object.approve2Price = item.approve2Price;
            object.approve2FloatingPrice = item.approve2FloatingPrice;
          } else if (this.businessApplicationVO.approveStatus === 20) {
            object.finApprovePrice = item.finApprovePrice;
            object.finApproveFloatingPrice = item.finApproveFloatingPrice;
          } else {
            object.approve3Price = item.approve3Price;
            object.approve3FloatingPrice = item.approve3FloatingPrice;
          }
          object.pkid = item.pkid;
          billParam.push(object);
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };
        this.$emit("loading-status", {loading: true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {loading: false});
            this.$message.success("保存成功");
            if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              this.updateHandle();
            }
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/BusinessApplication",
            });
          })
          .catch(() => {
            this.$emit("loading-status", {loading: false});
          });
      },
      updateHandle() {
        this.$http.post("basic", "sd/ba/update", this.businessApplicationVO).then((res) => {
          console.log(res);
        });
      },

      changeIsHidden() {
        this.loading = true;
        this.$nextTick(() => {
          for (let item of this.businessApplicationVO.allApplicationPriceWrapperS) {
            this.$refs.multipleTable.toggleRowExpansion(item, this.isHidden);
          }
          this.loading = false;
        });
        this.isHidden = !this.isHidden;
      },

      openPreviewPage(row) {
        if (this.businessApplicationVO.approveStatus === 3) {
          this.$refs.previewPage.open(this.businessApplicationVO.customerID, row);
        } else {
          this.$message.error("无权限打开预览页面");
        }
      },

      priceInput(value) {
        if (this.nodeId === "regionManager") {
          if (this.businessApplicationVO.priceVOS.length) {
            this.businessApplicationVO.priceVOS.forEach((item) => {
              item.approve2Price = item.approve3Price = value;
            });
          }
        } else {
          this.businessApplicationVO.priceVOS.forEach((item) => {
            item.approve3Price = value;
          });
        }
      },
    },
  };
</script>
